export default __webpack_public_path__ + "static/media/airj-m.e8f1ae6d.jpg";